import React, { Component } from 'react'
import './App.css';
import Home from './components/pages/new-design/components/Home/HomeComponent'
import About from './components/pages/new-design/components/About/AboutComponent'
import Pocket from './components/pages/new-design/components/Pocket/PocketComponent';
import SavingPlan from './components/pages/new-design/components/SavingsPlan/SavingsPlanComponent';
import Blog from './components/pages/new-design/blog/BlogComponent';
import Terms from './components/pages/new-design/components/Terms/TermsComponent';
import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import Faqs from './components/pages/new-design/components/Faqs/FaqsComponent';
import Privacy from './components/pages/new-design/components/Privacy/PrivacyComponent';
// import { ApolloProvider } from 'react-apollo';
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
  from,
} from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import ArticleDetailBannerComponent from './components/pages/new-design/blog/widget/ArticleDetails/ArticleDetailComponent';

const errorLink = onError(({ graphqlErrors, networkError }) => {
  if (graphqlErrors) {
    graphqlErrors.map(({ message, location, path }) => {
      alert(`Graphql error ${message}`);
    });
  }
});

const link = from([
  errorLink,
  new HttpLink({ uri: "https://apis.yalla.ng/graphql" }),
  // new HttpLink({ uri: "https://yallabackend.herokuapp.com/graphql" }),
  // new HttpLink({ uri: process.env.REACT_APP_NOT_SECRET_CODE }),
  // new HttpLink({ uri: "https://rickandmortyapi.com/graphql" }),
]);

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: link,
});



export default class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/pocket" component={Pocket} />
          <Route path="/savings-plan" component={SavingPlan} />
          <Route path="/terms" component={Terms} />
          <Route path="/faqs" component={Faqs} />
          <Route path="/privacy" component={Privacy} />
          <Route path="/blog" component={Blog} />
          <Route path="/blogs/:id" component={ArticleDetailBannerComponent} />
        </Switch>
      </Router>
      </ApolloProvider>
    )
  } 
}
